import React from 'react';
import { termsAndConditions } from '../data/termsAndConditions';
import Header from './Header';

function TermsAndConditionsPage({ onClose, user, userName, userPhone, onOpenOrders, onOpenAddresses, onOpenCart, cartCount, onLogout, onHelp }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100dvh',
      background: 'var(--bg-primary)',
      overflow: 'hidden'
    }}>
      <Header
        showSearch={false}
        isSignedIn={Boolean(user)}
        userName={userName}
        userPhone={userPhone}
        onLogoClick={null}
        onOpenOrders={onOpenOrders}
        onOpenAddresses={onOpenAddresses}
        onOpenCart={onOpenCart}
        cartCount={cartCount}
        onLogout={onLogout}
        onHelp={onHelp}
        showBackButton={true}
        onBackClick={onClose}
      />

      {/* Content */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: '20px',
      }}>
        {/* Last Updated */}
        <div style={{
          background: '#e7d5d5ff',
          border: '1px solid var(--warning-bg)',
          borderRadius: '12px',
          padding: '12px 16px',
          marginBottom: '24px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}>
          <span style={{ fontSize: '20px' }}>📋</span>
          <div>
            <div style={{ fontSize: '13px', fontWeight: '600', color: 'var(--warning-dark)' }}>
              Last Updated
            </div>
            <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>
              {termsAndConditions.lastUpdated}
            </div>
          </div>
        </div>

        {/* Company Info */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '24px',
          border: '1px solid var(--border-light)',
          boxShadow: 'var(--shadow-sm)',
        }}>
          <h2 style={{
            margin: '0 0 12px 0',
            fontSize: '18px',
            fontWeight: '700',
            color: 'var(--text-primary)',
          }}>
            {termsAndConditions.companyName}
          </h2>
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: 'var(--text-secondary)',
            lineHeight: '1.6',
          }}>
            {termsAndConditions.companyAddress}
          </p>
        </div>

        {/* Sections */}
        {termsAndConditions.sections.map((section, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              borderRadius: '16px',
              padding: '20px',
              marginBottom: '16px',
              border: '1px solid var(--border-light)',
              boxShadow: 'var(--shadow-sm)',
            }}
          >
            <h3 style={{
              margin: '0 0 12px 0',
              fontSize: '16px',
              fontWeight: '700',
              color: 'var(--primary)',
            }}>
              {section.title}
            </h3>
            <div style={{
              fontSize: '14px',
              color: 'var(--text-secondary)',
              lineHeight: '1.7',
              whiteSpace: 'pre-line',
            }}>
              {section.content}
            </div>
          </div>
        ))}

        {/* Footer Note */}
        <div style={{
          background: 'var(--primary-bg)',
          borderRadius: '12px',
          padding: '16px',
          marginTop: '24px',
          marginBottom: '20px',
          textAlign: 'center',
        }}>
          <p style={{
            margin: 0,
            fontSize: '13px',
            color: 'var(--primary-dark)',
            lineHeight: '1.6',
          }}>
            By using {termsAndConditions.companyName}, you agree to these Terms and Conditions.
            <br />
            Please read them carefully.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditionsPage;

// Made with Bob
